<article #chartcontainer>
	<main title="{{width}} x {{height}}">
		<div class="chart" [ngStyle]="{ 'height': height, 'width': width}">

			<canvas id="{{id}}" [ngStyle]="{ 'height': height, 'width': width}"></canvas>

		</div>
	</main>
</article>
